module.exports = __webpack_public_path__ + "static/media/ycombinator_featured.09bc3efb.jpeg";